import { render, staticRenderFns } from "./VDashboardPersonalData.vue?vue&type=template&id=14c2f5f8&scoped=true&"
import script from "./VDashboardPersonalData.vue?vue&type=script&lang=js&"
export * from "./VDashboardPersonalData.vue?vue&type=script&lang=js&"
import style0 from "./VDashboardPersonalData.vue?vue&type=style&index=0&id=14c2f5f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c2f5f8",
  null
  
)

export default component.exports